import React from 'react'
import DtcRowExtended from './DtcRowExtended'
import Pagination from '../../common/Pagination'
import NoRecordsFound from '../../common/NoRecordsFound'

const DtcTable = ({ dtcs, pagination, getPaginatedData, vehicleSid }) => (
  <div className="font-light">
    <div className="flex flex-row w-full bg-tracer-lt-blue rounded-t-lg text-white px-3 text-sm">
      <div className="flex w-2/12 pl-10 items-center">DTC Name</div>
      <div className="flex w-6/12 pl-6 items-center">Description</div>
      <div className="flex w-1/12 pl-6 items-center">ECU</div>
      <div className="flex w-1/12 pl-6 items-center">Active</div>
      <div className="w-1/12 pl-6">Destination Only?</div>
      <div className="w-1/12 pl-6">Mappings, Qty</div>
    </div>
    {dtcs?.length < 1 && (
      <NoRecordsFound
        loading={false}
        caption={'Vehicle DTCS data loading...'}
      />
    )}

    {dtcs.map((dtc) => (
      <DtcRowExtended key={dtc.id} {...dtc} vehicleSid={vehicleSid} />
    ))}

    <div className="py-6">
      <Pagination
        context={pagination}
        onClickNext={(e) => {
          getPaginatedData(e)
        }}
        onClickPrev={(e) => {
          getPaginatedData(e)
        }}
      />
    </div>
  </div>
)

DtcTable.propTypes = {}

export default DtcTable
